import AssignPercentagesError from './AssignPercentagesError';
class BeneficiaryDoesNotBelongToInvestor extends AssignPercentagesError {
    constructor(options) {
        super('The beneficiary does not belong to the investor', options);
    }
}
export default BeneficiaryDoesNotBelongToInvestor;
